export default __webpack_public_path__ + "static/media/08_pru.97baf2a5.png";